import InfoItem from "../../../components/InfoItem";

const TabGeneralInfo = (response) => {
  return (
    <div className="">
      <div className="grid grid-cols-2 gap-6">
        <InfoItem label="Tổ chức/công ty" value={response.data.companyName} />
        <InfoItem label="Người đại diện" value={response.data.fullName} />
        <InfoItem label="Email" value={response.data.email} />
        <InfoItem label="Số điện thoại" value={response.data.phone} />
      </div>
      <div className="grid grid-cols-3 gap-6">
        <InfoItem
          label="Website"
          value={
            <span className="text-blue-500 hover:underline">
              {response.data.website}
            </span>
          }
        />
        <InfoItem label="Phone" value={response.data.phone} />
        <InfoItem label="Mã số thuế" value={response.data.MST} />
        <InfoItem label="Tỉnh/Thành phố" value={response.data.address?.city} />
        <InfoItem label="Quận/Huyện" value={response.data.address?.district} />
        <InfoItem label="Địa chỉ" value={response.data.address?.detail} />
      </div>
    </div>
  );
};

export default TabGeneralInfo;
